import React from 'react';
import './MinimalistButton.css';

const MinimalistButton = ({ onClick, children }) => (
  <button className="minimalist-button" onClick={onClick}>
    {children}
  </button>
);

export default MinimalistButton;
